export const routes = [
    {
        context: 'audit',
        method: 'GET',
        path: '/audit',
        operationId: 'Audit_list',
        auth: 'tenant',
        action: 'audit:list',
        tool: 'audit_Audit_list',
        description: "The caller's tenant's audit log, newest first; `since` / `until` bound it by time.",
        pathParams: [],
        queryParams: ['cursor', 'limit', 'since', 'until', 'action', 'resourceKind'],
        hasBody: false,
        successStatus: 200,
    },
];
//# sourceMappingURL=routes.js.map